var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"RatioCropper"},[_c('div',{style:({
      width: '100%',
      height: 0,
      paddingBottom: ((100 / _vm.ratio) + "%"),
      overflow: 'hidden',
      position: 'relative'
    })},[_c('api-picture',{attrs:{"picture-id":_vm.pictureId,"update":_vm.update,"picture_class":_vm.pictureClass,"with_authors":_vm.with_authors,"lazy":_vm.lazy},on:{"rawLoad":_vm.handleLoad,"load":_vm.emitPictureObject}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }